import {
  GuardianType,
  UpdateGuardianType
} from 'apps/user/types/on-boarding.type';
import { GuardianTypeEnum } from 'apps/user/types/user.enum.type';
import { AxiosError, AxiosInstance } from 'axios';
import { Guardian, Guardians } from 'service/dto/guardian.dto';
import { errorHandler } from 'utils';

class GuardianService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createGuardian = async (guardian: GuardianType) => {
    try {
      const response = await this.baseService.post(
        '/guardian/create',
        guardian
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  checkIfEmailInUse = async (email: string) => {
    const response = await this.baseService.get(
      `/guardian/email-exists/${email}`
    );
    return response.data;
  };

  updateTrustee = async (
    trusteeId: number,
    updateGuardianType: UpdateGuardianType
  ) => {
    try {
      const response = await this.baseService.put(
        `/guardian/${trusteeId}`,
        updateGuardianType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getGuardians = async (search?: string | undefined): Promise<Guardians> => {
    try {
      const response = await this.baseService.get(`/guardian?search=${search}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deleteGuardian = async (guardianId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(`/guardian/${guardianId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignGuardian = async (
    guardianId: number,
    childrenIds: number[],
    type: GuardianTypeEnum
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch('/guardian/assign', {
        guardianId,
        childrenIds,
        type
      });
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getGuardian = async (guardianId: number): Promise<Guardian> => {
    try {
      const response = await this.baseService.get(`/guardian/${guardianId}`);
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getGuardianDetails = async (guardianId: number): Promise<Guardian> => {
    try {
      const response = await this.baseService.get(
        `/guardian/details/${guardianId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default GuardianService;
